var ciaEnvList = {
    inte: 'http://inte-cia.chanapp.chanjet.com',
    moni: 'http://moni-cia.chanapp.chanjet.com',
    prod: 'https://cia.chanapp.chanjet.com'
};
var clientId = 'tplusclient';
var clientSecret = 'pwjd5q';
var cspAk = (typeof __AK__ !== 'undefined' ? btoa(__AK__) : "OGY0NDJlYzMtNzEzZS00MTMzLWI2NGMtNWQyZDgyOGM1NDI2");
var cspAS = (typeof __AS__ !== 'undefined' ? btoa(__AS__) : 'amp5M3Vo');
var proxyServer = 'http://cloudproxy01.chanapp.chanjet.com';
var authKey = 'AuthKey';
var authKeys = ['userId', 'OrganID', 'accessToken', 'orgId', 'tplusToken', 'sid', 'authorization'];
var channelKey = 'ChannelKey';
var channelKeys = ['targetURL', 'throughProxy'];
var clientInfoKey = 'ClientInfoKey';
var ciaHostArray = [ciaEnvList['inte'], ciaEnvList['moni'], ciaEnvList['prod']];
var ciaHost = (typeof __CIA_ENV__ !== 'undefined' ? ciaEnvList[__CIA_ENV__] : ciaEnvList['prod']);
var tplusWebAppApiHost = 'https://webapp.tplus.chanjet.com/TPlus/api/v1/';
var tplusHostArray = ['http://webapp.tplus.chanjet.com', 'https://webapp.tplus.chanjet.com', 'http://test-webapp.tplus.chanjet.com', 'https://test-webapp.tplus.chanjet.com'];
var noProxyHostArray = ['log.aliyuncs.com'];
var noErrorTips = ['log.aliyuncs.com'];
var devProxyHost = 'http://' + (typeof __PROXY_URL__ !== 'undefined' ? __PROXY_URL__ : 'localhost') + ':' + (typeof __PROXY_PORT__ !== 'undefined' ? parseInt(__PROXY_PORT__) + 1 : '3001') + '/proxy';
var prodProxyHost = 'https://tfproxy.chanjet.com';
export { clientId, clientSecret, cspAk, cspAS, proxyServer, authKey, authKeys, channelKey, channelKeys, clientInfoKey, ciaHostArray, tplusHostArray, devProxyHost, prodProxyHost, ciaHost, tplusWebAppApiHost, noProxyHostArray, noErrorTips };

//# sourceMappingURL=app.js.map
